export default function AboutSection() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-emerald-100 rounded-full mb-6">
              <span className="text-sm font-semibold text-emerald-700">Chi Siamo</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Leader nel <strong>Risparmio Energetico</strong> ad Arezzo
            </h2>
            <p className="text-base text-gray-700 mb-6 leading-relaxed">
              <strong>GLOBAL ENERGY SRL</strong> è una società con sede ad Arezzo, dotata di un capitale sociale pari a <strong>€ 390.000,00</strong>, attiva da oltre dieci anni nel settore edile e, in particolare, nel comparto dei materiali e delle soluzioni orientate al <strong>risparmio energetico</strong>.
            </p>
            <p className="text-base text-gray-700 mb-6 leading-relaxed">
              Nel corso della propria attività, la società ha sviluppato competenze specialistiche che le hanno consentito di affermarsi come operatore affidabile e strutturato nel panorama nazionale del <strong>risparmio energetico</strong> e delle <strong>energie rinnovabili</strong>.
            </p>
            <p className="text-base text-gray-700 mb-8 leading-relaxed">
              Grazie a oltre un decennio di operatività nel settore del <strong>risparmio energetico</strong>, GLOBAL ENERGY SRL ha maturato un know-how consolidato e una profonda conoscenza del mercato, costruendo nel tempo rapporti duraturi con clienti, fornitori e partner commerciali.
            </p>

            <div className="grid grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-100 rounded-lg flex-shrink-0">
                  <i className="ri-shield-check-line text-xl text-emerald-600"></i>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-900 mb-1">Affidabilità</h3>
                  <p className="text-sm text-gray-600">Oltre 10 anni di esperienza</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-100 rounded-lg flex-shrink-0">
                  <i className="ri-award-line text-xl text-emerald-600"></i>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-900 mb-1">Qualità</h3>
                  <p className="text-sm text-gray-600">Materiali certificati</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-100 rounded-lg flex-shrink-0">
                  <i className="ri-team-line text-xl text-emerald-600"></i>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-900 mb-1">Competenza</h3>
                  <p className="text-sm text-gray-600">Team specializzato</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-100 rounded-lg flex-shrink-0">
                  <i className="ri-customer-service-line text-xl text-emerald-600"></i>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-900 mb-1">Supporto</h3>
                  <p className="text-sm text-gray-600">Assistenza dedicata</p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="w-full h-64 rounded-2xl overflow-hidden">
                  <img 
                    src="https://public.readdy.ai/ai/img_res/3af016186e3115ad9f62ad41629f8574.jpg"
                    alt="Installazione pannelli fotovoltaici"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-full h-48 rounded-2xl overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=close%20up%20view%20of%20high%20efficiency%20solar%20panel%20cells%20with%20detailed%20geometric%20patterns%20and%20reflective%20blue%20surface%20showing%20modern%20renewable%20energy%20technology%20clean%20professional%20product%20photography%20with%20soft%20lighting&width=400&height=300&seq=about002&orientation=landscape"
                    alt="Pannelli solari dettaglio"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="w-full h-48 rounded-2xl overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=modern%20industrial%20steel%20structure%20framework%20construction%20site%20with%20geometric%20metal%20beams%20and%20professional%20engineering%20work%20clean%20organized%20workspace%20with%20natural%20lighting%20and%20industrial%20architecture%20aesthetic&width=400&height=300&seq=about003&orientation=landscape"
                    alt="Strutture in ferro"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-full h-64 rounded-2xl overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=aerial%20view%20of%20large%20scale%20commercial%20solar%20farm%20installation%20with%20rows%20of%20photovoltaic%20panels%20on%20industrial%20building%20rooftop%20showing%20renewable%20energy%20infrastructure%20and%20sustainable%20technology%20bright%20daylight%20professional%20architectural%20photography&width=400&height=500&seq=about004&orientation=portrait"
                    alt="Impianto fotovoltaico"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            <div className="absolute -bottom-8 -left-8 bg-emerald-600 text-white rounded-2xl p-6 shadow-xl max-w-xs">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg">
                  <i className="ri-building-line text-2xl"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold">P.IVA</p>
                  <p className="text-sm opacity-90">IT-02198440519</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
